import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Field, { fieldTypes } from "components/Field";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

const DateRangeModal = ({
  title,
  buttonText,
  validator,
  action,
  fromDate,
  toDate,
}) => {
  const dispatch = useDispatch();

  const [from, setFrom] = useState(fromDate);
  const [fromError, setFromError] = useState("");
  const [to, setTo] = useState(toDate);
  const [toError, setToError] = useState("");

  const isEnabled = () => from && to && fromError === "" && toError === "";

  const handleOk = () => {
    if (isEnabled()) {
      let error = false;
      if (validator) {
        error = !validator(from, to, setFromError, setToError);
      }
      if (!error) {
        action(from, to);
        dispatch(hideModal(modalTypes.DATE_RANGE));
      }
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.DATE_RANGE));
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter") {
      handleOk();
    }
  };

  return (
    <Modal
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
      onKeyDown={onEnterKeyDown}
      data-testid="date-range-modal"
    >
      <Modal.Header>
        <b>{title}</b>
      </Modal.Header>
      <Modal.Body>
        <div className="report_period__modal">
          <Field
            type={fieldTypes.date}
            propsObject={{
              date: from,
              setDate: setFrom,
              dateError: fromError,
              labelText: "From date",
              validator: () => {},
            }}
          />

          <Field
            type={fieldTypes.date}
            propsObject={{
              date: to,
              setDate: setTo,
              dateError: toError,
              labelText: "To date",
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Close
        </NewButton>

        <NewButton
          data-testid="saveButton"
          variant={NewButtonVariant.l1}
          onClick={handleOk}
          disabled={!isEnabled()}
        >
          {buttonText}
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default DateRangeModal;

DateRangeModal.propTypes = {
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  validator: PropTypes.func,
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  action: PropTypes.func.isRequired,
};
